import React from "react";
import { IconArrowDown } from "../../../../Components/Icons";
import { CollapseHeaderContent } from "./MediaAssetsLabs.styled";

export const CollapseHeader = ({ active, onClick, text }) => {
  return (
    <CollapseHeaderContent onClick={onClick} active={active}>
      <IconArrowDown size={30} />
      {text}
    </CollapseHeaderContent>
  );
};
